module.exports = __webpack_public_path__ + "img/icon9.e36498f3.png";